/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_MaxrepsInputs */

const fr_pr_type_maxreps = /** @type {(inputs: Pr_Type_MaxrepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions max`)
};

/**

* @param {Pr_Type_MaxrepsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_maxreps = /** @type {((inputs?: Pr_Type_MaxrepsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_MaxrepsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_maxreps(inputs)
});